/**
 * Internal dependencies
 */
import type { State } from './types';

export const INIT_STATE: State = {
	segmentationRuleTypes: {},
	categories: {},
};
